
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { AlertTimingEnum, AlertTypeEnum, LinearAlertModel, TenantUserModel } from '@/libs/Api';
import { linearAlertsStore } from '@/libs/alerts/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import Toast from '@/libs/common/components/Toast.vue';
import NotificationAlertsTable from '@/libs/settings/components/NotificationAlertsTable.vue';

@Component({
    components: { Toast, NotificationAlertsTable },
})
export default class Notifications extends Page {
    @Prop() tenantId!: string;

    loading = true;
    alerts: LinearAlertModel[] = [];
    showToastSaved = false;
    tenantUsers: TenantUserModel[] = [];

    protected AlertTypeEnum: typeof AlertTypeEnum = AlertTypeEnum;
    protected AlertTimingEnum: typeof AlertTimingEnum = AlertTimingEnum;

    mounted() {
        this.loadAll();
    }

    private async loadAll() {
        try {
            // Load tenant users for Autocomplete
            tenantUsersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
            // Load linear alerts
            linearAlertsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
            await Promise.all([
                this.subscribe(tenantUsersStore, CrudReponse.GetAll).then((users: TenantUserModel[]) => {
                    this.tenantUsers = users ?? [];
                }),
                this.subscribe(linearAlertsStore, CrudReponse.GetAll).then((items: LinearAlertModel[]) => {
                    const linqItems = items as any;
                    this.alerts = linqItems && typeof linqItems.toArray === 'function' ? linqItems.toArray() : items;
                }),
            ]);
        } finally {
            this.loading = false;
        }
    }

    private async reloadAlerts() {
        linearAlertsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
        const items: LinearAlertModel[] = await this.subscribe(linearAlertsStore, CrudReponse.GetAll);
        const linqItems = items as any;
        this.alerts = linqItems && typeof linqItems.toArray === 'function' ? linqItems.toArray() : items;
    }

    
}
